import styled from 'styled-components';
import Wra16A from 'dc/Wra16A';
import Ico36 from 'dc/Ico36';
import { Typ42 } from 'dc/Typ';
import Lab010 from 'dc/Lab010';

export const Wrapper = styled.div`
  background: #ffffff;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 32px;
`;

export const WrapperStd = styled(Wra16A)`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Icon = styled(Ico36)`
  color: #00ab97;
`;

export const Title = styled(Typ42)`
  text-align: center;
`;

export const Label = styled(Lab010)`
  > i {
    color: #607d8b;
  }

  > span {
    color: #607d8b;
  }
`;
